import React from "react";
import { LayoutMain } from "../../components/common";
import "./About.css";
function About() {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;
  return (
    <LayoutMain>
      <div className="about-wrapper">
        <div className="info-general">
          <h2>
            KaMikaze Travel sind Katharina und Michael aus dem Pinzgau in
            Salzburg.
          </h2>
          <p>
            Gemeinsam haben wir versucht die schönsten alpinen Landschaften in
            Österreich, Europa und der Welt zu entdecken. Dabei half uns, dass
            es dort, wo man Klettern, Bergsteigen und Trekken kann üblicherweise
            auch sehr schön ist. Diese Fleckchen Erde möchten wir nun mit euch
            teilen und weiter erforschen. Zuhause sind wir in Saalbach, einem
            Schizentrum und unterschätztem Juwel als Ausgangspunkt für Alpines
            Klettern, Eisklettern, Sportklettern, Hochtouren und natürlich
            Schitouren.
          </p>
          <div className="info-general-image">
            <img src={`${baseImagePath}/aboutUs/aboutDiving.jpg`} alt="Scenery" />
          </div>
        </div>
        <div className="about-us-container">
          <div className="image-container">
            <img src={`${baseImagePath}/aboutUs/about_test.jpg`} alt="Scenery" />
          </div>
          <div className="info-container">
            <h2>Katharina Kortschak, MA</h2>
            <p>
              Katharinas Leidenschaft für das, was sie tut, und ihre Neugier,
              ständig Neues zu lernen, haben sie zur Projektmanagerin,
              Softwareentwicklerin und Reiseveranstalterin gemacht. In den
              letzten zehn Jahren konnte sie sich beruflich in einem Reisebüro
              für Erlebnisreisen, in der Regionalentwicklung und im
              Projektmanagement in verschiedenen Bereichen verwirklichen. Als
              Skilehrerin, Rettungsschwimmerin und begeisterte Reisende
              verbindet Katharina Bergsteigen, Klettern und Rennradfahren mit
              Kultur, Tauchen und – je nach landschaftlicher Gegebenheit – mit
              einsamen Tundren oder sonnigen Strandbuchten. Schöne Erinnerungen
              hat sie nicht nur von ihren weltweiten Reisen mitgenommen, sondern
              auch von ihren Wohnorten in der Steiermark, Ober- und
              Niederösterreich, Wien, Amerika, Südamerika und Kärnten. Seit 2023
              lebt sie im Pinzgau im Bundesland Salzburg. Dort baut sie seit
              Sommer 2024 zusammen mit ihrem Lebensgefährten und mit dem
              notwendigen Quäntchen Mut, neuen Ideen und viel Motivation
              "KaMikaze Travel" auf.
            </p>
          </div>
          {/*} <div className="statement-container statement-right">
            <p className="statement-text">
              "The best view comes after the hardest climb."
            </p>
          </div>*/}
        </div>

        <div className="about-us-container right-aligned">
          {/*<div className="statement-container statement-left">
            <p className="statement-text">"Explore, Dream, Discover"</p>
          </div>*/}
          <div className="info-container">
            <h2>Mag. Michael Reisecker</h2>
            <p>
              Michael ist staatlich geprüfter Berg- und Schiführer, Kletterer
              und Schifahrer aus Leidenschaft. Er arbeitet als Physiker,
              Softwareentwickler und Projektmanager im Bereich der
              Lawinenprognostik und ist im Ausbildungsteam des
              Lawinenwarndienstes Tirol, sowie Beobachter für die
              Lawinenwarndienste in mehreren Bundesländern. Er ist Verfasser von
              Artikeln in den Ausbildungshandbüchern der Österreichischen Berg-
              und Schiführer und der Tiroler Lawinenkommissionen, Salzburger
              Landesschi- und Segellehrer, Forstwirt aus Liebhaberei, hat seit
              Kindestagen die Welt bereisen dürfen und fotografiert dabei mit
              Passion. Er lebte zeitweilig in Salzburg, Tirol, der Steiermark
              und Kärnten und suchte dort nach den weniger ausgetretenen Pfaden.
            </p>
          </div>
          <div className="image-container">
            <img src={`${baseImagePath}/aboutUs/about_test_michi.jpg`}  alt="BF" />
          </div>
        </div>
      </div>
    </LayoutMain>
  );
}

export default About;
